import { useFilePicker } from 'use-file-picker';
import ImageEditor from 'react-avatar-editor';
import React from 'react';
import Slider from '@ui/Slider';
import Button from '@ui/Button';
import { MdEditSquare } from 'react-icons/md';

function ProfileAvatarEditor(props) {
  const { profileImage, setEditorRef, newProfileImage, setIsUploaded } = props;

  const [imageToEdit, setImageToEdit] = React.useState(profileImage);
  const [zoom, setZoom] = React.useState(1);

  const [openFileSelector, { filesContent, loading, errors: fileErrors }] =
    useFilePicker({
      readAs: 'DataURL',
      accept: 'image/*',
      multiple: false,
      maxFileSize: 5, // in megabytes
    });

  const showFileSelector = () => {
    openFileSelector();
  };

  React.useEffect(() => {
    if (filesContent && filesContent[0]) {
      setImageToEdit(filesContent[0].content);
      setIsUploaded(true);
    }
  }, [filesContent]);

  React.useEffect(() => {
    if (newProfileImage) {
      setImageToEdit(newProfileImage);
    }
  }, [newProfileImage]);
  const handleZoom = ([value]) => {
    setZoom(1 + value / 100);
  };

  return (
    <div className="relative flex flex-col gap-4">
      <ImageEditor
        ref={setEditorRef}
        image={imageToEdit}
        width={250}
        height={250}
        borderRadius={125}
        border={1}
        color={[255, 255, 255, 0.6]} // RGBA
        scale={zoom}
        className="rounded-md bg-body-background"
        crossOrigin="anonymous"
      />

      <div className="absolute left-[212px] top-1">
        <Button variant="icon" onClick={showFileSelector} className="bg-white">
          <MdEditSquare className="h-6 w-6 text-primary" />
        </Button>
      </div>

      <Slider onValueChange={handleZoom} showValue={false} />
    </div>
  );
}

export default ProfileAvatarEditor;
